import React from 'react';
import { InputBase, InputGroup } from '@milanote/roma';

type Props = {
    value: string;
    onChange: (value: string) => void;
    handleSearchSubmit: () => void;
};

const TagsSearchBar = ({ value, onChange, handleSearchSubmit }: Props) => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        handleSearchSubmit();
    };

    return (
        <div className="TagsSearchBar mb-3">
            <form onSubmit={handleSubmit}>
                <InputGroup size="sm" onChange={onChange} aria-label="Enter tag name">
                    <InputBase type="text" placeholder="Enter tag name..." value={value} />
                </InputGroup>
            </form>
        </div>
    );
};

export default TagsSearchBar;
